import React, { FC, useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { Option } from 'components/atoms/select/types';
import { BaseSelect } from 'components/organisms/task-pane/task-detail/task-fields/task-custom-fields/fields/base-select';
import { SingleSelectField as SingleSelectFieldT } from 'components/organisms/tasks/fields';
import { FieldHelper } from 'utils/field';

interface FieldProps {
  field: SingleSelectFieldT;
  disabled?: boolean;
  onChange?: (selected: number | null, field: SingleSelectFieldT) => void;
  isPlaceholderShown?: boolean;
}

export const SingleSelectField: FC<FieldProps> = ({
  field,
  onChange,
  disabled = false,
  isPlaceholderShown = true,
}) => {
  const { value = null } = field;
  const [state, setState] = useState<Option | null>(null);

  const {
    options: { activeOptions, allOptions },
  } = FieldHelper(field);

  /* TODO:: can be moved to common hook(useSingleSelectState) just like useInput. so that, single-user select also can share the code */
  useDeepCompareEffect(() => {
    const selected =
      allOptions.find((option) => option.value === value) || null;

    setState(selected);
  }, [allOptions, value]);

  const commit = (newlySelected: Option | null) => {
    setState(newlySelected);
    if (onChange) {
      onChange(newlySelected ? Number(newlySelected.value) : null, field);
    }
  };

  return (
    <BaseSelect
      disabled={disabled}
      options={activeOptions}
      value={state}
      onChange={commit}
      isPlaceholderShown={isPlaceholderShown}
      data-cy={`right.content.single.select.${field.fieldLabel}`}
    />
  );
};
